import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { TAPDetailsPageComponent } from './details-page/details-page.tap.component';
// import { TAPPaymentComponent } from './payment/payment.tap.component';

/* REPLICATED FILES */
import { INDRADetailsPageComponent } from './details-page/details-page.indra.component';
import { INDRAPaymentPageComponent } from '.././payment/payment-page/payment-page.indra.component';

import { INDRABookingPaymentRedirectResolver } from '@ibe.resolvers/booking-payment-page-redirect-indra.resolver';

// Phase 1 codes:
import { CountryCodesIndraResolver } from '@ibe.resolvers/country-codes-indra.resolver';
import { CountryConversionCodesIndraResolver } from '@ibe.resolvers/country-conversion-codes-indra.resolver';
import { EUCountryCodesIndraResolver } from '@ibe.resolvers/eu-country-codes-indra.resolver';
import { USAirportsIndraResolver } from '@ibe.resolvers/us-airports-indra.resolver';
import { USStatesIndraResolver } from '@ibe.resolvers/us-states-indra.resolver';
import { SchengenCountryCodesIndraResolver } from '@ibe.resolvers/schengen-country-codes-indra.resolver';


const timeTothinkRoutes: Routes = [
	{
		path: '',
		children: [
			{
				path: '', component: INDRADetailsPageComponent
			},
			{
				path: 'payment/redirect/:pnr', 
				component: INDRAPaymentPageComponent, 
				data: { title: 'Payment' },
				resolve: {
					paymentRedirect: INDRABookingPaymentRedirectResolver,
					countryCodes: CountryCodesIndraResolver,
					countryConversionCodes: CountryConversionCodesIndraResolver,
					USAirports: USAirportsIndraResolver,
					USStates: USStatesIndraResolver,
					schengenCountryCodes: SchengenCountryCodesIndraResolver,
					euCountryCodes: EUCountryCodesIndraResolver
				}
			},
			{
				path: 'payment', 
				component: INDRAPaymentPageComponent, 
				data: { title: 'Payment' },
				resolve: {
					countryCodes: CountryCodesIndraResolver,
					countryConversionCodes: CountryConversionCodesIndraResolver,
					USAirports: USAirportsIndraResolver,
					USStates: USStatesIndraResolver,
					schengenCountryCodes: SchengenCountryCodesIndraResolver,
					euCountryCodes: EUCountryCodesIndraResolver
				}
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(timeTothinkRoutes)],
	exports: [RouterModule]
})
export class TimeTothinkRoutesRoutingModule { }
